import { endPoints, requestType } from "../lib/variable";
import Api from "./index";
const getAllJobTitle = () => {
  return Api(endPoints.getJobTitle, null, requestType.GET);
};
const createJobTitle = (params) => {
  return Api(endPoints.createJobTitle, params, requestType.POST);
};
const updateJobTitle = (id, params) => {
  return Api(`${endPoints.updateJobTitle}/${id}`, params, requestType.POST);
};
const deleteJobTitle = (id, payload) => {
  return Api(`${endPoints.deleteJobTitle}/${id}`, payload, requestType.DELETE);
};
export { getAllJobTitle, createJobTitle, updateJobTitle, deleteJobTitle };
